/** Get the list of dropdown options in the given menu element. */
export const getDropdownOptions = (el: HTMLElement) =>
  Array.from(el.querySelectorAll('.dropdown-option'));

/** Get the focused dropdown option (if any) in the given menu element. */
export const getFocusedOption = (el: HTMLElement) =>
  el.querySelector('.dropdown-option.focused');
